// app-init.factory.ts

import { ConfigRepo } from '@shared/services/configsService/config-repo.service';
import { ConfigApiDTO } from '@shared/services/configsService/config.dto';
import { BaseApiService } from '@shared/services/apiService/base-api.service';
import { firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';
import { HttpHeaders } from '@angular/common/http';

export function configFactory(
  configApiService: BaseApiService<ConfigApiDTO>,
  configsRepo: ConfigRepo,
) {
  return async () => {
    try {
      const response = await firstValueFrom(configApiService.withHeader(
        new HttpHeaders({
          Authorization: `Bearer ${environment.config_token}`,
          'X-Skip-Interceptor': '',
        })
      ).get({
        where: {
          dbUser: {
            equals: environment.db_user || 'default user',
          },
        },
      }));
      configsRepo.patchConfig(configsRepo.parseDtoToRecord(response));
    } catch (error) {
      console.error(' > ConfigFactory | Error getting config data from db: ', error);
      throw error;
    }
  };
}
